export function renderStars(stars) {
  let renderedStars = '';
  if (stars && stars[0] > 0 && stars[0] <= 9) {
    for (let i = 0; i < stars[0]; i++) {
      renderedStars += '★';
    }
    stars = stars.substr(1);
  }
  if (stars) {
    renderedStars += stars.toUpperCase();
  }
  return renderedStars;
}

export function wordSlice(sentence, start, end) {
  let words = sentence.split(/\s+/);
  start = start || 0;
  end = end || words.length;
  words = words.slice(start, end);
  return words.join(' ');
}
